<app-action-icon #iconCmp
                 [value]="isFavorite"
                 [state]="state"
                 (toggle)="toggleFavorite($event)"
                 class="event-favorite-icon__container"
                 [class.event-favorite-icon__container--active]="isFavorite"
                 [class.event-favorite-icon__container--hover]="iconCmp.hover">
  <mat-icon
    [matTooltip]="tooltip"
    class="event-favorite-icon__icon"
    [class.event-favorite-icon__icon--active]="isFavorite"
    [class.event-favorite-icon__icon--hover]="iconCmp.hover">
    {{icon}}
  </mat-icon>
</app-action-icon>
